import { Content, FormattedProps } from './types';

export default (content: Content): FormattedProps => ({
  src: content.url
});
